import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useProceedingCreate } from '@/module/Author/Proceeding/model/ProceedingQuery';
import {
  ProceedingSchema,
  defaultProceedingValues,
  proceedingSchema,
} from '@/module/Author/Proceeding/model/ProceedingSchema';
import { Proceeding } from '@/module/Author/Proceeding/model/ProceedingTypes';
import { ImportItem } from '@/module/Sync/model/SyncTypes';

import { dangerouslyConvertType, useAppNotification } from '@feature/utils';

import { ProceedingForm } from './ProceedingForm';

interface ProceedingSyncProps {
  onSuccess: (proceeding: Proceeding) => void;
  item: ImportItem;
  onCancel: () => void;
  sourceType: string;
}

function convert(item: ImportItem, sourceType: string): ProceedingSchema {
  return dangerouslyConvertType<ProceedingSchema>({
    ...item,
    bdis: [],
    wosCategories: [],
    wosIndexes: [],

    language: null,
    sourceType,
  });
}

export function ProceedingSync({ onSuccess, item, onCancel, sourceType }: ProceedingSyncProps) {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useProceedingCreate();
  const notification = useAppNotification();

  const onSubmit = (values: ProceedingSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newProceeding => {
        notification.success();
        onSuccess(newProceeding);
      },
    });
  };

  return (
    <>
      <Text>{item.journalName}</Text>
      <ProceedingForm
        title={t('proceedings.form.title.create')}
        schema={proceedingSchema}
        defaultValues={defaultProceedingValues}
        values={convert(item, sourceType)}
        isSubmitting={isPending}
        isError={isError}
        isSuccess={isSuccess}
        onSubmit={onSubmit}
        onCancel={onCancel}
        showWosFields={false}
        showScopusFields={false}
      />
    </>
  );
}
